import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import ExpansionPanelComp from '../../common/ExpansionPanelComp';
import DatiRiepilogo from './DatiRiepilogo';

const styles = theme => ({
  root: {
    width: '100%',
  },
});
			
function DatiRiepilogoPanel(props) {
	
  const { classes } = props;
  return (
    <div className={classes.root}> 
      <ExpansionPanelComp titolo={'datiRiepilogo'} componente={DatiRiepilogo} senzaLensIcon={true} /> 
    </div>
  );
}

DatiRiepilogoPanel.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DatiRiepilogoPanel);
